import * as React from 'react';
import {observer} from 'mobx-react';
import {Button} from '@vidazoo/ui-kit';
import {Player} from '@lottiefiles/react-lottie-player';
import animation from '../../../assets/noAccess.json';
import useSessionManager from '../../../modules/session/hooks/useSessionManager';
import theme from './theme.module.scss';

export interface INoAccessScreenProps {
    title?: string;
    description?: string;
}

function NoAccessScreen({
                            title = "You don't have permissions for this system",
                            description = 'Your account is missing the required access. Please contact your administrator to request access.'
                        }: INoAccessScreenProps): React.JSX.Element {
    const sessionManager = useSessionManager();

    const onSignOut = () => sessionManager.logout();

    return (
        <div className={theme.container}>
            <div className={theme.card}>
                <div className={theme.animation}>
                    <Player
                        autoplay
                        loop
                        src={animation}
                        style={{width: '160px', height: '160px'}}
                    />
                </div>
                <h1 className={theme.title}>{title}</h1>
                <p className={theme.description}>
                    {description}
                </p>
                <div className={theme.actions}>
                    <Button medium className={theme.signOut} onClick={onSignOut}>
                        Sign out
                    </Button>
                </div>
            </div>
        </div>
    );
}

export default observer(NoAccessScreen);
